










































































import {
	defineComponent,
	Ref,
	ref,
} from '@vue/composition-api';
import { useConfirmDialog } from '@vueuse/core';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import ConfirmationModal from '@front-app/components/modals/ConfirmationModal.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import EditorPanels from '@front-app/components/userProfile/editing/EditorPanels.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import PresentOccupation from '@front-app/components/userProfile/main/PresentOccupation.vue';
import ProfileCardRoles from '@front-app/modules/user/components/ProfileCardRoles.vue';
import ProfileInterests from '@front-app/components/userProfile/main/ProfileInterests.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { GroupFilter } from '@front-app/views/home/groups/GroupEnum';
import { GroupListQuery } from '@front-app/router/util/groupListQuery';
import { EditableSection } from '@front-app/components/userProfile/editableProfileSections';
import { FocusableElement } from '@front-app/hooks/useAsyncModal';
import { OrganizationsStore } from '@front-app/store/singletons/Organizations';
import { Routes } from '@front-app/constants/routes';
import { Size } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { UserProfileOptionsStore } from '@front-app/store/singletons/UserProfileOptions';

export default defineComponent({
	components: {
		ColumnContainer,
		ColumnHeader,
		ConfirmationModal,
		CtaButton,
		EditorPanels,
		PaddedContent,
		PresentOccupation,
		ProfileCardRoles,
		ProfileInterests,
	},
	setup(props, ctx) {
		OrganizationsStore.fetchAllPartial();
		const { currentUser } = CurrentUserStore;

		const currentEditSection: Ref<EditableSection> = ref(EditableSection.NONE);
		const currentEditExperienceId: Ref<undefined | number> = ref(undefined);
		const returnTo: Ref<null | FocusableElement> = ref(null);

		const openEditModal = async (targetSection: EditableSection, newReturnTo: FocusableElement) => {
			currentEditExperienceId.value = undefined;
			returnTo.value = newReturnTo;
			currentEditSection.value = targetSection;
		};
		const openEditExperienceModal = async (experienceId: number, newReturnTo: FocusableElement) => {
			currentEditExperienceId.value = experienceId;
			returnTo.value = newReturnTo;
			currentEditSection.value = EditableSection.PROFESSIONAL_EXPERIENCE;
		};

		// Roles and navigation
		const hasConfirmedRoles = ref(false);
		const confirmRoles = useConfirmDialog();

		const navigateToHomeOrRedirect = () => {
			const redirectURL = localStorage.getItem('redirect_url');
			if (redirectURL) {
				localStorage.removeItem('redirect_url');
				ctx.root.$router.push(redirectURL);
			} else {
				ctx.root.$router.push({ name: Routes.GROUPS, query: { [GroupListQuery.FILTERS]: GroupFilter.INVITES } });
			}
		};

		confirmRoles.onCancel(() => {
			hasConfirmedRoles.value = true;
			navigateToHomeOrRedirect();
		});

		const {
			track,
			isLoading: isLoadingProfileOptions,
		} = useAsyncStatus();

		const fetchOptionsAndOpenPanel = async (section: EditableSection) => {
			await track(UserProfileOptionsStore.fetch());
			currentEditSection.value = section;
		};

		const confirmRolesOrNavigate = () => {
			if (!hasConfirmedRoles.value) {
				confirmRoles.reveal();
			} else {
				navigateToHomeOrRedirect();
			}
		};

		return {
			currentUser,
			returnTo,
			// Occupation
			openEditModal,
			openEditExperienceModal,
			currentEditSection,
			currentEditExperienceId,
			EditableSection,
			// Roles and navigation
			hasConfirmedRoles,
			confirmRoles,
			confirmRolesOrNavigate,
			// Profile options
			fetchOptionsAndOpenPanel,
			isLoadingProfileOptions,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
